var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_box_cla",attrs:{"id":"content_box_id"}},[_c('div',{class:'left-item-cla '+_vm.leftClass,style:(_vm.leftStyle)},[_vm._t("left")],2),_vm._v(" "),_c('div',{class:'right-item-cla '+_vm.rightClass,style:(_vm.rightStyle)},[_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5303d4f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/content.vue
// module id = null
// module chunks = 